export const CODE_LOAD_DATA_FAIL = 100;
export const CODE_DB_UPDATE_FAIL = 101;
export const CODE_DB_DELETE_FAIL = 102;